<div class="field">
  <label *ngIf="showLabel" for="customerBaSelector" class="do-not-wrap-text">{{labelKey}}</label>
  <div class="p-inputgroup">
    <p-dropdown #customerBaSelector id="customerBaSelector"
                [options]="customerBusinessAreas"
                editable="true"
                [(ngModel)]="customerBusinessArea"
                placeholder="Выбор категории"
                filterPlaceholder="Поиск..."
                [filter]="true"
                [disabled]="_disabled"
                [autofocusFilter]="false" 
                [virtualScroll]="true"
                [virtualScrollItemSize]="31"
                (onChange)="onChangeCS($event)"
                (onClick)="onClickCS($event)"
                (onClear)="onClearCS($event)"
                class="p-dropdown-filter"></p-dropdown>
    <p-button icon="pi pi-plus" styleClass="p-button-success ml-1" (onClick)="onCurrencyAddButton($event)" disabled="areaExists"
              pTooltip="Добавить новую категорию покупателя" tooltipPosition="top" *ngIf="doShowAddCurrencyButton"></p-button>
  </div>
</div>
